import { render, staticRenderFns } from "./zhiJiGaoKao.vue?vue&type=template&id=43f01b7c&scoped=true&"
import script from "./zhiJiGaoKao.vue?vue&type=script&lang=js&"
export * from "./zhiJiGaoKao.vue?vue&type=script&lang=js&"
import style0 from "./zhiJiGaoKao.vue?vue&type=style&index=0&id=43f01b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f01b7c",
  null
  
)

export default component.exports